import React from 'react'
import { Image } from '@/atoms/Image'
import { useTranslate } from '@/utils/translate/translate-client'
import { GiveawayPrizeItem } from '@/views/PreSales/PreSalesGiveawayView/hooks/useGiveawayConfigData'
import { GEyebrowSM, GParagraphMD, GParagraphSM, GResponsiveText, GTitleSM, GTitleXS } from '../UI/Typography'

const prizes: GiveawayPrizeItem[] = [
  {
    image: 'https://images.angelstudios.com/image/upload/v1764189239/homestead-giveaway/updated/Humvee-Prize.webp',
    alt: 'Humvee',
    title: 'Humvee from Season 1 & 2',
    value: '$40,000',
    sponsorName: 'Bakcou',
  },
  {
    image: 'https://images.angelstudios.com/image/upload/v1727735729/Homestead/prizes/bitcoin-01.webp',
    alt: '$25,000 in Bitcoin',
    title: '$25,000 in BitCoin',
    value: '$25,000',
  },
  {
    image:
      'https://images.angelstudios.com/image/upload/v1764189237/homestead-giveaway/updated/Bakcou-Puma-X22-Giveaway.webp',
    alt: 'Bakcou Puma X22',
    title: 'Bakcou Puma X22',
    value: '$8,999',
    sponsorName: 'Bakcou',
  },
  {
    image:
      'https://images.angelstudios.com/image/upload/v1764189237/homestead-giveaway/updated/Vortex-Razor-Prize.webp',
    alt: 'Vortex RAZOR HD Gen III 1-10x24',
    title: 'Vortex RAZOR HD Gen III 1-10x24',
    value: '$4,000',
    sponsorName: 'Vortex',
  },
  {
    image:
      'https://images.angelstudios.com/image/upload/v1763588825/studio-app/catalog/6a51469d-0923-42f7-88db-64127cfedd97.webp',
    alt: 'Be Extras in Homestead Season 2, All Expenses Paid',
    title: 'Be Extras in Homestead Season 2, All Expenses Paid',
    value: '$3,000',
    representativePrizeShown: true,
  },
  {
    image:
      'https://images.angelstudios.com/image/upload/v1764189233/homestead-giveaway/updated/Cobalt-Kinetics-Prize.webp',
    alt: 'Cobalt Kinetics CK-Pro Rifle',
    title: 'Cobalt Kinetics CK-Pro Rifle',
    value: '$2,500',
    sponsorName: 'Cobalt Kinetics',
  },
  {
    image: 'https://images.angelstudios.com/image/upload/v1764189236/homestead-giveaway/updated/Goldbacks-Prize.webp',
    alt: '100 Goldbacks',
    title: '100 Goldbacks',
    value: '$800',
    sponsorName: 'Goldback',
  },
  {
    image:
      'https://images.angelstudios.com/image/upload/v1764189240/homestead-giveaway/updated/Water-Purification-Prize.webp',
    alt: 'Water Purification by Black Sentry + Condition 1',
    title: 'Water Purification by Black Sentry + Condition 1',
    value: '$500',
    sponsorName: 'Black Sentry + Condition 1',
  },
  {
    image:
      'https://images.angelstudios.com/image/upload/v1764189234/homestead-giveaway/updated/Flame_Thrower-Prize.webp',
    alt: 'Exothermic Pulsefire Flamethrower',
    title: 'Exothermic Pulsefire Flamethrower',
    value: '$500',
    sponsorName: 'Exothermic Technologies',
  },
  {
    image: 'https://images.angelstudios.com/image/upload/v1764189234/homestead-giveaway/updated/My-Medic-Prize.webp',
    alt: 'MyMedic Recon Pro',
    title: 'MyMedic Recon Pro',
    value: '$440',
    sponsorName: 'MyMedic',
  },
  {
    image: 'https://images.angelstudios.com/image/upload/v1764189235/homestead-giveaway/updated/SLNT-Prize.webp',
    alt: 'SLNT Faraday Bag',
    title: 'SLNT Faraday Bag',
    value: '$200',
    sponsorName: 'SLNT',
  },
  {
    image: 'https://images.angelstudios.com/image/upload/v1764189239/homestead-giveaway/updated/Uncharted-Prize.webp',
    alt: 'Uncharted Dry Bag',
    title: 'Uncharted Dry Bag',
    value: '$180',
    sponsorName: 'Uncharted',
  },
  {
    image: 'https://images.angelstudios.com/image/upload/v1764123622/homestead-giveaway/Barrel-Prepared_Hero.webp',
    alt: 'Prepared Hero Fire Extinguisher',
    title: 'Prepared Hero Fire Extinguisher',
    value: '$100',
    sponsorName: 'Prepared Hero',
  },
  {
    image: 'https://images.angelstudios.com/image/upload/v1764189241/homestead-giveaway/updated/Black_Beard_Prize.webp',
    alt: 'Black Beard Lifeline',
    title: 'Black Beard Lifeline',
    value: '$99',
    sponsorName: 'Black Beard',
  },
]

export const HomesteadSeriesPrizeItemsTabContent: React.FC = () => {
  const { t } = useTranslate('giveaway')

  return (
    <div className="w-full px-4">
      <div className="my-10 md:mt-16">
        <GResponsiveText
          color="giveaway-text-subtle-light"
          className="mt-3"
          MobileTextComponent={GParagraphSM}
          DesktopTextComponent={GParagraphMD}
        >
          {t(
            'prizeItemsDescriptionLabelHomesteadSeries',
            'Explore the incredible prizes in this giveaway— own the Humvee from Season 1, be an extra in Season 2, and be prepared for anything with this "Escape and Evade" package!',
          )}
        </GResponsiveText>
      </div>
      <div className="border-giveaway-accent-light mb-5 mt-10 w-full flex-col justify-between border-b pb-1 lg:flex">
        <div>
          <GTitleSM color="giveaway-primary">{t('prizeItems', 'Prize Items')}</GTitleSM>
        </div>

        <div>
          <GTitleXS color="giveaway-primary">
            {t('overValueInPrizes', 'Over {{ value }} in Prizes', { value: '$85,000' })}
          </GTitleXS>
        </div>
      </div>

      <div className="mb-10 grid gap-6 lg:grid-cols-2">
        {prizes
          .filter((prizeItem): prizeItem is GiveawayPrizeItem & { value: string } => !!prizeItem.value)
          .map((prizeItem, index) => (
            <PrizeItem
              key={index}
              image={prizeItem.image}
              alt={prizeItem.alt}
              title={prizeItem.title}
              value={prizeItem.value}
              sponsorName={prizeItem.sponsorName}
              representativePrizeShown={prizeItem.representativePrizeShown}
            />
          ))}
      </div>
    </div>
  )
}

interface PrizeItemProps {
  image: string
  alt: string
  title: string
  value: string
  sponsorName?: string
  representativePrizeShown?: boolean
}

const PrizeItem = ({ image, alt, title, value, representativePrizeShown }: PrizeItemProps) => {
  const { t } = useTranslate('tickets')

  return (
    <div className="group flex flex-col py-4">
      <div className="aspect-h-9 aspect-w-16 relative overflow-hidden rounded-none">
        <Image
          src={image}
          alt={alt}
          fill
          className="object-cover transition-transform duration-300 group-hover:scale-[1.03]"
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
        />
        {representativePrizeShown && (
          <div className="absolute inset-0 ">
            <div className="relative h-full w-full">
              <Image
                src={'/v1747076634/repprizebig_ty4oa1.png'}
                alt={'Representitive Prize Shown'}
                fill
                className="object-cover transition-transform duration-300 group-hover:scale-[1.03]"
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              />
            </div>
          </div>
        )}
      </div>
      <div className="flex justify-between gap-4 pb-1 pt-4">
        <div className="w-2/3">
          <GEyebrowSM color="giveaway-text-subtle-light">{t('item', 'item')}</GEyebrowSM>
          <GParagraphMD color="giveaway-primary">{title}</GParagraphMD>
        </div>
        <div>
          <GEyebrowSM color="giveaway-subtle">{t('value', 'value')}</GEyebrowSM>
          <GParagraphMD color="giveaway-primary">{value}</GParagraphMD>
        </div>
      </div>
    </div>
  )
}
